/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertyType } from '../models/PropertyType';
import type { PublicSiteFilterOptionsResponse } from '../models/PublicSiteFilterOptionsResponse';
import type { PublicSiteManifest } from '../models/PublicSiteManifest';
import type { PublicSiteOperation } from '../models/PublicSiteOperation';
import type { PublicSitePriceMode } from '../models/PublicSitePriceMode';
import type { PublicSiteProperty } from '../models/PublicSiteProperty';
import type { PublicSitePropertySearchResponse } from '../models/PublicSitePropertySearchResponse';
import type { PublicSitePropertySort } from '../models/PublicSitePropertySort';
import type { WebsiteAnalyticsResponse } from '../models/WebsiteAnalyticsResponse';
import type { WebsiteDomainCreateRequest } from '../models/WebsiteDomainCreateRequest';
import type { WebsiteDomainRecord } from '../models/WebsiteDomainRecord';
import type { WebsiteLogoFinalizeResponse } from '../models/WebsiteLogoFinalizeResponse';
import type { WebsiteLogoUploadSessionCreate } from '../models/WebsiteLogoUploadSessionCreate';
import type { WebsiteLogoUploadSessionRecord } from '../models/WebsiteLogoUploadSessionRecord';
import type { WebsitePreviewSessionRecord } from '../models/WebsitePreviewSessionRecord';
import type { WebsitePublishRequest } from '../models/WebsitePublishRequest';
import type { WebsiteReadResponse } from '../models/WebsiteReadResponse';
import type { WebsiteTemplateRegistryFinalize } from '../models/WebsiteTemplateRegistryFinalize';
import type { WebsiteTemplateRegistryFinalizeResponse } from '../models/WebsiteTemplateRegistryFinalizeResponse';
import type { WebsiteTemplateRegistryListResponse } from '../models/WebsiteTemplateRegistryListResponse';
import type { WebsiteTemplateRegistryRecord } from '../models/WebsiteTemplateRegistryRecord';
import type { WebsiteTemplateRegistryRevisionsResponse } from '../models/WebsiteTemplateRegistryRevisionsResponse';
import type { WebsiteTemplateRegistryTemplateSummary } from '../models/WebsiteTemplateRegistryTemplateSummary';
import type { WebsiteTemplateRegistryUpdate } from '../models/WebsiteTemplateRegistryUpdate';
import type { WebsiteTemplateRegistryUploadSessionCreate } from '../models/WebsiteTemplateRegistryUploadSessionCreate';
import type { WebsiteTemplateRegistryUploadSessionRecord } from '../models/WebsiteTemplateRegistryUploadSessionRecord';
import type { WebsiteTemplateRegistryValidationReport } from '../models/WebsiteTemplateRegistryValidationReport';
import type { WebsiteUpsertRequest } from '../models/WebsiteUpsertRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WebsitesService {
    /**
     * @returns WebsiteTemplateRegistryListResponse Ok
     * @throws ApiError
     */
    public static listTemplateRegistryEntries(): CancelablePromise<WebsiteTemplateRegistryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/template-registry',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WebsiteTemplateRegistryUploadSessionRecord Ok
     * @throws ApiError
     */
    public static createTemplateRegistryUploadSession(
        requestBody: WebsiteTemplateRegistryUploadSessionCreate,
    ): CancelablePromise<WebsiteTemplateRegistryUploadSessionRecord> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/websites/template-registry/upload-sessions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WebsiteTemplateRegistryFinalizeResponse Ok
     * @throws ApiError
     */
    public static finalizeTemplateRegistryUpload(
        requestBody: WebsiteTemplateRegistryFinalize,
    ): CancelablePromise<WebsiteTemplateRegistryFinalizeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/websites/template-registry/finalize',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param registryTemplateId
     * @param requestBody
     * @returns WebsiteTemplateRegistryRecord Ok
     * @throws ApiError
     */
    public static updateTemplateRegistryEntry(
        registryTemplateId: string,
        requestBody: WebsiteTemplateRegistryUpdate,
    ): CancelablePromise<WebsiteTemplateRegistryRecord> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/websites/template-registry/{registryTemplateId}',
            path: {
                'registryTemplateId': registryTemplateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param registryTemplateId
     * @returns WebsiteTemplateRegistryRevisionsResponse Ok
     * @throws ApiError
     */
    public static listTemplateRegistryRevisions(
        registryTemplateId: string,
    ): CancelablePromise<WebsiteTemplateRegistryRevisionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/template-registry/{registryTemplateId}/revisions',
            path: {
                'registryTemplateId': registryTemplateId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param registryTemplateId
     * @param revisionId
     * @returns WebsiteTemplateRegistryValidationReport Ok
     * @throws ApiError
     */
    public static getTemplateRegistryValidationReport(
        registryTemplateId: string,
        revisionId: string,
    ): CancelablePromise<WebsiteTemplateRegistryValidationReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/template-registry/{registryTemplateId}/revisions/{revisionId}/validation-report',
            path: {
                'registryTemplateId': registryTemplateId,
                'revisionId': revisionId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @returns WebsiteTemplateRegistryTemplateSummary Ok
     * @throws ApiError
     */
    public static listTemplates(): CancelablePromise<Array<WebsiteTemplateRegistryTemplateSummary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/templates',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @returns any Ok
     * @throws ApiError
     */
    public static getCurrentWebsite(): CancelablePromise<WebsiteReadResponse | null> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/current',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WebsiteReadResponse Ok
     * @throws ApiError
     */
    public static upsertCurrentWebsite(
        requestBody: WebsiteUpsertRequest,
    ): CancelablePromise<WebsiteReadResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/websites/current',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param days
     * @returns any Ok
     * @throws ApiError
     */
    public static getCurrentWebsiteAnalytics(
        days?: number,
    ): CancelablePromise<WebsiteAnalyticsResponse | null> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/current/analytics',
            query: {
                'days': days,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WebsitePreviewSessionRecord Ok
     * @throws ApiError
     */
    public static createPreviewSession(
        requestBody: WebsiteUpsertRequest,
    ): CancelablePromise<WebsitePreviewSessionRecord> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/websites/current/preview-sessions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WebsiteLogoUploadSessionRecord Ok
     * @throws ApiError
     */
    public static createLogoUploadSession(
        requestBody: WebsiteLogoUploadSessionCreate,
    ): CancelablePromise<WebsiteLogoUploadSessionRecord> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/websites/current/logo/upload-sessions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param uploadSessionId
     * @returns WebsiteLogoFinalizeResponse Ok
     * @throws ApiError
     */
    public static finalizeLogoUpload(
        uploadSessionId: string,
    ): CancelablePromise<WebsiteLogoFinalizeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/websites/current/logo/upload-sessions/{uploadSessionId}/finalize',
            path: {
                'uploadSessionId': uploadSessionId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WebsiteReadResponse Ok
     * @throws ApiError
     */
    public static publishCurrentWebsite(
        requestBody: WebsitePublishRequest,
    ): CancelablePromise<WebsiteReadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/websites/current/publish',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param previewSessionId
     * @returns PublicSiteManifest Ok
     * @throws ApiError
     */
    public static getPreviewManifest(
        previewSessionId: string,
    ): CancelablePromise<PublicSiteManifest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/preview-sessions/{previewSessionId}/manifest',
            path: {
                'previewSessionId': previewSessionId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param previewSessionId
     * @returns PublicSiteFilterOptionsResponse Ok
     * @throws ApiError
     */
    public static getPreviewFilterOptions(
        previewSessionId: string,
    ): CancelablePromise<PublicSiteFilterOptionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/preview-sessions/{previewSessionId}/filter-options',
            path: {
                'previewSessionId': previewSessionId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param previewSessionId
     * @param operation
     * @param propertyType
     * @param countryCode ISO 3166-1 alpha-2 country code used to scope public property results.
     * @param regionCode
     * @param localityCode
     * @param neighborhood
     * @param search
     * @param priceMode
     * @param minPrice
     * @param maxPrice
     * @param minBedrooms
     * @param minBathrooms
     * @param minParkingLots
     * @param minAreaTotal
     * @param maxAreaTotal
     * @param sort
     * @param size
     * @param pageToken
     * @returns PublicSitePropertySearchResponse Ok
     * @throws ApiError
     */
    public static listPreviewProperties(
        previewSessionId: string,
        operation?: PublicSiteOperation,
        propertyType?: Array<PropertyType>,
        countryCode?: string,
        regionCode?: string,
        localityCode?: string,
        neighborhood?: string,
        search?: string,
        priceMode?: PublicSitePriceMode,
        minPrice?: number,
        maxPrice?: number,
        minBedrooms?: number,
        minBathrooms?: number,
        minParkingLots?: number,
        minAreaTotal?: number,
        maxAreaTotal?: number,
        sort?: PublicSitePropertySort,
        size?: number,
        pageToken?: string,
    ): CancelablePromise<PublicSitePropertySearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/preview-sessions/{previewSessionId}/properties',
            path: {
                'previewSessionId': previewSessionId,
            },
            query: {
                'operation': operation,
                'propertyType': propertyType,
                'countryCode': countryCode,
                'regionCode': regionCode,
                'localityCode': localityCode,
                'neighborhood': neighborhood,
                'search': search,
                'priceMode': priceMode,
                'minPrice': minPrice,
                'maxPrice': maxPrice,
                'minBedrooms': minBedrooms,
                'minBathrooms': minBathrooms,
                'minParkingLots': minParkingLots,
                'minAreaTotal': minAreaTotal,
                'maxAreaTotal': maxAreaTotal,
                'sort': sort,
                'size': size,
                'pageToken': pageToken,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param previewSessionId
     * @param propertyId
     * @returns PublicSiteProperty Ok
     * @throws ApiError
     */
    public static getPreviewProperty(
        previewSessionId: string,
        propertyId: number,
    ): CancelablePromise<PublicSiteProperty> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/websites/preview-sessions/{previewSessionId}/properties/{propertyId}',
            path: {
                'previewSessionId': previewSessionId,
                'propertyId': propertyId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WebsiteDomainRecord Ok
     * @throws ApiError
     */
    public static createDomain(
        requestBody: WebsiteDomainCreateRequest,
    ): CancelablePromise<WebsiteDomainRecord> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/websites/current/domains',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
    /**
     * @param domainId
     * @returns WebsiteReadResponse Ok
     * @throws ApiError
     */
    public static verifyDomain(
        domainId: number,
    ): CancelablePromise<WebsiteReadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/websites/current/domains/{domainId}/verify',
            path: {
                'domainId': domainId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                429: `Too many requests`,
            },
        });
    }
}
